<template>
  <div class="filter">
    <div class="filterContainer">
      <div class="mr10" v-if="searchParams.terminalId === 1">
        <span class="tar title">导航类型：</span>
        <a-select
          ref="select"
          v-model:value="postParams.navType"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="-1">全部</a-select-option>
          <a-select-option :value="'header'">header</a-select-option>
          <a-select-option :value="'footer'">footer</a-select-option>
        </a-select>
      </div>
      <div class="mr10" v-if="searchParams.terminalId === 1">
        <span class="tar title">适用终端：</span>
        <a-select
          ref="select"
          v-model:value="postParams.subChannel"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="-1">全部</a-select-option>
          <a-select-option :value="1">PC</a-select-option>
          <a-select-option :value="2">M</a-select-option>
        </a-select>
      </div>
      <div class="mr10">
        <span class="tar title">状态：</span>
        <a-select
          ref="select"
          v-model:value="postParams.status"
          style="width: 220px"
          :allowClear="true"
        >
          <a-select-option :value="-1">全部</a-select-option>
          <a-select-option :value="0">未使用</a-select-option>
          <a-select-option :value="1">使用中</a-select-option>
        </a-select>
      </div>
      <div class="mr10 tar">
        <a-button class="mr10" @click="() => resetParams()">重置</a-button>
        <a-button type="primary" @click="resetPagination">查询</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      open: false
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.filter {
  background: #ffffff;
}

.filterContainer {
  display: flex;
  flex-direction: row;
}

.filter .title {
  display: inline-block;
}
</style>
